//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      form: {},
      option: {
        labelWidth: 110,
        column: [{
          label: "姓名",
          prop: "name"
        }]
      }
    };
  },
  methods: {
    handleBack: function handleBack() {
      this.$router.$avueRouter.closeTag();
      this.$router.back();
    }
  }
};